<ng-container *ngIf="showMap && showSearchBar">
  <div class="form-group" style="z-index: 99999">
    <label for="autocomplete-places" class="visually-hidden"
      >Cerca per luogo</label
    >
    <input
      type="search"
      class="autocomplete"
      placeholder="Cerca per luogo"
      aria-label="Cerca per luogo"
      aria-describedby="autocomplete-places"
      id="autocomplete-places"
      name="autocomplete-places"
      [formControl]="mapControl"
    />
    <span class="autocomplete-icon" aria-hidden="true">
      <svg class="icon icon-sm" aria-label="Cerca per luogo">
        <use href="/bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
      </svg>
    </span>
    <ul *ngIf="(filteredOptions | async)?.length">
      <li
        *ngFor="let option of filteredOptions | async"
        (click)="search(option.title)"
      >
        {{ option.title }}
      </li>
    </ul>
  </div>
  <div id="map"></div>
</ng-container>

<ng-container *ngIf="showMap && !showSearchBar">
  <div id="map" style="height: 450px"></div>
</ng-container>
